/* istanbul ignore file */

// TODO: Need to address coverage issues

import dynamic from 'next/dynamic';

import type { LayoutComponentProps, SiteChromeLayoutComponentProps } from './types';
import { LayoutTypes } from './types';

const ClientSiteChromeUI = dynamic<SiteChromeLayoutComponentProps>(() =>
  import(
    /* webpackChunkName: "layout__client_site_chrome_ui" */ './ClientSiteChromeUI/ClientSiteChromeUI'
  ).then((mod) => mod.ClientSiteChromeUI),
);

const Minimal = dynamic<LayoutComponentProps>(() =>
  import(/* webpackChunkName: "layout__minimal" */ './Minimal/Minimal').then((mod) => mod.Minimal),
);

const layoutStrategy = {
  [LayoutTypes.MINIMAL]: Minimal,
  [LayoutTypes.CLIENT_SITE_CHROME_UI]: ClientSiteChromeUI,
};

export const getLayout = (type: LayoutTypes) => layoutStrategy[type];
